import axios from "axios";

const instanceApi = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_URL,
})

export default instanceApi